import { Editor } from "@tiptap/react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../select/Select";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/util";
import { convertEmailTypeToForm } from "../../util/email";
import TemplateIcon from "../icons/TemplateIcon";

const Skabeloner = (props: {
  editor: Editor;
  type: IEmailTypes;
  setFieldValue: (
    field: keyof ISendEmailControl,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => void;
}) => {
  const { editor, setFieldValue, type } = props;
  const { data, isLoading, error } = useQuery<ISkabelonerResponseItem[]>({
    queryKey: [`skabeloner-${type}`],
    queryFn: async function () {
      return get({ query: "email/skabeloner" });
    },
  });
  if (error) return <div>Der opstod en fejl</div>;
  if (isLoading) {
    return (
      <Select disabled>
        <SelectTrigger
          button
          badge
          className="btn--transparent btn-secondary text-muted"
          aria-label="Email-skabeloner"
          placeholder="Laster skabeloner..."
          icon={<TemplateIcon />}
        />
      </Select>
    );
  }
  if (!data || data.length === 0) {
    return (
      <Select disabled>
        <SelectTrigger
          button
          badge
          className="btn--transparent btn-secondary"
          aria-label="Email-skabeloner"
          placeholder="Vælg skabelon"
          icon={<TemplateIcon />}
        />
      </Select>
    );
  }
  const templateType = convertEmailTypeToForm(type);
  const templates = data.filter((template) => template.type === templateType);

  return (
    <Select
      onValueChange={(index) => {
        const template = templates[parseInt(index)];
        editor.commands.setContent(template.indhold);
        setFieldValue("emne", template.emne);
        setFieldValue("vedhaeftelser", template.vedhaeftelser);
        setFieldValue("afsenderEmailAdresse", template.afsender);
      }}
    >
      <SelectTrigger
        button
        badge
        className="btn--transparent btn-secondary"
        aria-label="Email-skabeloner"
        placeholder="Vælg skabelon"
        icon={<TemplateIcon />}
      />
      <SelectContent scrollable>
        {templates.map((t, i) => (
          <SelectItem key={i} value={i.toString()}>
            {t.navn}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default Skabeloner;
